import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer'
import { AppraisalsType } from 'Models/appraisalsType'

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  footer: {
    position: 'absolute',
    fontSize: 9,
    bottom: 15,
    left: 0,
    right: 0,
    textAlign: 'center',
  },
  sectionTitle: {
    fontSize: 12,
    marginVertical: 6,
    fontWeight: 'bold',
  },
  table: {
    // display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ccc',
    marginBottom: 12,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCol: {
    flex: 1,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ccc',
    padding: 4,
  },
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: '#f0f0f0',
  },
  question: {
    marginBottom: 4,
    fontSize: 9,
  },
  answer: {
    marginBottom: 8,
    fontSize: 9,
    fontStyle: 'italic',
  },
})

const AppraisalPDF = ({ dataset }: { dataset: AppraisalsType[] | undefined }) => (
  <Document
    title='Employee Appraisal Report'
    author='TG - Management'
    subject='Performance Appraisals'
    keywords='TG, hr, appraisal, performance'
    creator='TG EMP Portal'
    producer='TG - Management'
  >
    {dataset?.map((appraisal, index) => (
      <Page size='A4' style={styles.page} key={index}>
        <View style={styles.header}>
          <View>
            <Text style={{ fontSize: 14, fontWeight: 'bold' }}>
              {appraisal.employee.firstName} {appraisal.employee.lastName}
            </Text>
            <Text>{appraisal.employee.emailAddress}</Text>
            <Text>Employee ID: {appraisal.employee.employeeId}</Text>
            <Text>
              Year: {appraisal.year} | Quarter: {appraisal.quarter}
            </Text>
          </View>
          {appraisal.employee?.photo?.url && (
            <Image
              src={appraisal.employee.photo.url}
              style={{ width: 60, height: 60, borderRadius: 30 }}
            />
          )}
        </View>

        <Text style={styles.sectionTitle}>Key Performance Indicators (KPI)</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            {['Metric', 'Target', 'Manager Score', 'Employee Score'].map((h) => (
              <Text key={h} style={[styles.tableCol, styles.tableHeader]}>
                {h}
              </Text>
            ))}
          </View>
          {appraisal.kpi.map((row: any, i: number) => (
            <View style={styles.tableRow} key={i}>
              <Text style={styles.tableCol}>{row.metric}</Text>
              <Text style={styles.tableCol}>{row.target}</Text>
              <Text style={styles.tableCol}>{row.manager_score}</Text>
              <Text style={styles.tableCol}>{row.employee_score}</Text>
            </View>
          ))}
        </View>

        <Text style={styles.sectionTitle}>Core Values</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            {['Category', 'Question', 'Manager Score', 'Employee Score'].map((h) => (
              <Text key={h} style={[styles.tableCol, styles.tableHeader]}>
                {h}
              </Text>
            ))}
          </View>
          {appraisal.coreValues.map((row: any, i: number) => (
            <View style={styles.tableRow} key={i}>
              <Text style={styles.tableCol}>{row.category}</Text>
              <Text style={styles.tableCol}>{row.question}</Text>
              <Text style={styles.tableCol}>{row.manager_score}</Text>
              <Text style={styles.tableCol}>{row.employee_score}</Text>
            </View>
          ))}
        </View>

        <Text style={styles.sectionTitle}>Personal Assessment</Text>
        {appraisal.personalAssessment.map((item: any, i: number) => (
          <View key={i}>
            <Text style={styles.question}>
              {item.category}: {item.question}
            </Text>
            <Text style={styles.answer}>Answer: {item.answer}</Text>
          </View>
        ))}

        <Text style={styles.sectionTitle}>Review Summary</Text>
        <Text>Line Manager: {appraisal.lineManagerEmailAddress}</Text>
        <Text>Manager Comment: {appraisal.lineManagerComment || 'N/A'}</Text>
        <Text>Management Comment: {appraisal.managementComment || 'N/A'}</Text>
        <Text>Status: {appraisal.status}</Text>

        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
          fixed
        />
      </Page>
    ))}
  </Document>
)

export default AppraisalPDF
